/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-01 17:32:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-03 16:51:01
 * @FilePath: /src/app/(payment)/payment/components/Address/components/AddressPreview.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';
import { Address } from '@/api/types/public';
import Image from '@/components/Image';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { getAddressRules, getErrorTranslationKey } from '@/utils/form-rule';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import { RightArrowOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';

interface AddressPreviewProps {
  address: Address;
  addressList: Address[];
  onChooseAddress: (item: Address) => void;
  onEditAddress: (item: Address) => void;
  isMobile?: boolean;
  onOpenMobileChooseAddress: () => void;
  valid: boolean;
}

export default function AddressPreview({
  address,
  addressList,
  onChooseAddress,
  onEditAddress,
  isMobile,
  onOpenMobileChooseAddress,
  valid,
}: AddressPreviewProps) {
  const countryList = useStore((state) => state.countryList);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const tValidation = useTranslations('components.address.validation');
  const t = useTranslations('payment.address');

  const handleClick = (type: 'preview' | 'edit') => {
    if (type === 'preview' && !isMobile) {
      return;
    }

    if (addressList.length > 1 && !isMobile) {
      setAnchorEl(anchorEl ? null : containerRef.current);
    }

    if (isMobile) {
      onOpenMobileChooseAddress();
    }
  };

  const open = Boolean(anchorEl);

  const id = open ? 'simple-popper' : undefined;

  // 切换地址
  const chooseAddress = (item: Address) => {
    if (address.status === 2) return;
    onChooseAddress(item);
    setAnchorEl(null);
  };

  const getErrorMessage = (_address: Address) => {
    const errorCode = getAddressRules(_address, countryList);
    return errorCode && getErrorTranslationKey(errorCode)
      ? tValidation(getErrorTranslationKey(errorCode)!)
      : '';
  };
  const handleClickAway = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div
          ref={containerRef}
          onClick={() => handleClick('preview')}
          className={`p-[20px_12px] md:p-[min(4.56vw,20px)] relative  md:border-1 border-solid border-[#CCCCCC] rounded-[10px]  bg-white ${
            !valid ? 'border-1 border-[#BC1B1B]' : ''
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="md:w-3/4 word-break-all max-md:flex-1">
              <div className="md:flex items-center">
                {address.default === 1 && isMobile && (
                  <span className="inline-block py-[2px] px-[6px]  text-[10px] bg-primary-purple text-white rounded-[8px] mr-4">
                    {t('default')}
                  </span>
                )}
                <span className="text-[16px] leading-[20px] text-primary-black font-bb md:font-br">
                  {address.address || address.street}
                </span>
              </div>
              <p className="mt-8">
                <span className="text-[14px] md:text-sm mr-4 md:mr-20">
                  {address.firstname} {address.lastname}
                </span>
                <span className="text-[14px] md:text-sm">{address.telephone}</span>
                {address.default === 1 && !isMobile && (
                  <span className="inline-block py-[3px] px-[8px]  text-[14px] bg-primary-purple text-white rounded-[12px] ml-12">
                    {t('default')}
                  </span>
                )}
              </p>
              {!isMobile && (
                <p
                  className="mt-3 text-primary-purple text-[14px] font-bb underline cursor-pointer inline-block"
                  onClick={() => onEditAddress(address)}
                >
                  {t('edit')}
                </p>
              )}
            </div>
            <div className="flex items-center justify-center flex-shrink-0 md:justify-end">
              {addressList && (isMobile || addressList.length > 1) && (
                <RightArrowOutlined
                  onClick={() => handleClick('edit')}
                  className={`mr-[-10px] text-[22px] md:mr-[10px] md:text-[20px] cursor-pointer transition-all duration-300 ${isMobile ? '' : 'rotate-90'} ${
                    open && !isMobile ? 'rotate-270' : ''
                  }`}
                />
              )}
            </div>
          </div>
          {!!getErrorMessage(address) && (
            <div className="text-[#BC1B1B] mt-12">{getErrorMessage(address)}</div>
          )}
          {isMobile && (
            <Image
              src="/payment/address-line.png"
              alt="arrow-down"
              width={400}
              height={4}
              className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[95%] h-[4px] "
            />
          )}
        </div>
      </ClickAwayListener>
      <WebOnly>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          sx={{
            width: containerRef.current?.clientWidth,
            border: '1px solid #CCCCCC',
            borderRadius: '10px',
            paddingLeft: '30px',
            paddingRight: '30px',
            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)',
            backgroundColor: 'white',
            maxHeight: '300px',
            overflowY: 'auto',
            zIndex: 10,
          }}
        >
          {addressList.length > 0 &&
            addressList.map((item) => {
              // 剔除掉当前地址;
              if (item.id === address.id) {
                return null;
              }

              const errorMsg = getErrorMessage(item);
              return (
                <div
                  key={item.id}
                  onClick={(e) => {
                    if (errorMsg) {
                      // 防止冒泡
                      e.stopPropagation();
                      return;
                    }
                    chooseAddress(item);
                  }}
                  className={`border-b border-solid border-[#CCCCCC] py-24  ${
                    errorMsg ? 'cursor-not-allowed text-secondary-text' : 'cursor-pointer'
                  }`}
                >
                  <p className="text-[16px] leading-1.2 text-primary-black">{item.address}</p>
                  <p className="mt-10">
                    <span className="text-sm mr-20">
                      {item.firstname} {item.lastname}
                    </span>
                    <span className="text-sm">{item.telephone}</span>
                    {item.default === 1 && (
                      <span className="inline-block py-[5px] px-[8px]  text-[14px] bg-primary-purple text-white rounded-[12px] ml-12">
                        {t('default')}
                      </span>
                    )}
                  </p>
                  <p
                    className="mt-3 text-primary-purple text-[14px] font-bb underline cursor-pointer inline-block"
                    onClick={() => onEditAddress(item)}
                  >
                    {t('edit')}
                  </p>
                  {!!errorMsg && <div className="text-[#BC1B1B] mt-12 text-14">{errorMsg}</div>}
                </div>
              );
            })}
        </Popper>
      </WebOnly>
    </>
  );
}
